var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"area_page"}},[_c('div',{attrs:{"id":"main"}},[_c('div',{staticClass:"main-wrap",on:{"&scroll":function($event){return _vm.scollPos($event)}}},[_c('div',{staticClass:"rec-wrap"},[_c('vertical-list-component',{ref:"vertical"})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bfa0af1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/AreaPage.vue
// module id = null
// module chunks = 